module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element-card card"
  }, [(Object.keys(_vm.element).length > 0) ? _c('div', {
    staticClass: "card-block"
  }, [_c('h6', {
    staticClass: "card-title text-uppercase font-weight-bold"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("history.generalInformation")))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col d-flex align-items-center"
  }, [(_vm.discoveryAuthorImage) ? _c('a', {
    staticClass: "mr-4",
    attrs: {
      "href": _vm.discoveryAuthorImage,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "rounded-circle",
    attrs: {
      "src": _vm.discoveryAuthorImage
    }
  })]) : _vm._e(), _vm._v(" "), _c('featured-value', {
    staticClass: "mr-4",
    attrs: {
      "value": _vm.element.discoveryDate,
      "title": "history.discoveryDate",
      "element": _vm.element,
      "colored": true
    }
  }), _vm._v(" "), (!_vm.element.discoveryDate) ? _c('featured-value', {
    attrs: {
      "value": "???",
      "title": "history.discoveryDate",
      "element": _vm.element,
      "colored": true
    }
  }) : _vm._e(), _vm._v(" "), _c('featured-value', {
    attrs: {
      "value": _vm.element.discoveryAuthor,
      "title": "history.discoveredBy",
      "element": _vm.element
    }
  })], 1)]), _vm._v(" "), (_vm.element.context) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "text-muted mt-3 mb-0"
  }, [_vm._v(_vm._s(_vm.element.context))])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84e8729a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ElementProfile/ElementHistoricalProperties.vue
// module id = 648
// module chunks = 1